// extracted by mini-css-extract-plugin
export default {"addParameterButton":"add-parameter-button_addParameterButton__hyOQ0"};